import { $post } from '@/api'
import { BaseDialog } from '@/components/dialog/base-dialog'
import { Column, Row } from '@/components/layout/layout'
import SearchInput from '@/components/search-input/search-input'
import { IPagination } from '@/model/types/common'
import { errorCallBack } from '@/utils'
import useBemClass from '@/utils/hooks/useBEMClass'
import { layerManage, showLayer } from '@/utils/layer'
import { isNoMore, WithScrollLoad } from '@/utils/utils-widget'
import { useRequest, useUpdateEffect } from 'ahooks'
import { ColumnsType } from 'antd/lib/table'
import React, { useCallback, useState } from 'react'
import { GoodSaleByName } from '../type'
import { Table } from 'antd'
import './good-sale-search.scss'
import useSetDataTogether from '@/utils/hooks/useSetDataTogether'
import WordHighLight from '@/components/word-highlight/word-highlight'
import { GoodsDetail } from '../../../goods-manage/goods-storage/goods-library/modules/goods-detail/goods-detail'

interface GoodSaleSearchProps {
    date: (string | undefined)[]
}

const GoodSaleSearch: React.FC<GoodSaleSearchProps> = props => {
    const cls = useBemClass('good-sale-search')

    const [key, setKey] = useState<string>('')
    const [sortKey, setSortKey] = useState<string | undefined>(void 0)
    const [des, setDes] = useState<boolean | undefined>(void 0)
    const setAllData = useSetDataTogether()

    const setSortParams = useCallback(
        (sorter: any) => {
            const sortKeyNameMap: Record<string, string> = {
                net_order_count: '3',
                net_sales_count: '4',
                net_sales_income: '2',
            }
            setAllData(() => {
                setSortKey(sortKeyNameMap[sorter.field])
                setDes(sorter.order === void 0 ? void 0 : sorter.order === 'descend')
            })
        },
        [setAllData],
    )

    const goodNameColumns: ColumnsType<GoodSaleByName.GoodsDataList> = [
        {
            title: '#',
            width: 40,
            align: 'center',
            render: (v, r, i) => i + 1,
        },
        {
            title: '商品名称',
            render: (v, r, i) => (
                <Column>
                    <WordHighLight
                        keyword={key}
                        word={r.goods.name}
                        classes="text-ellipsis-one"
                        style={{
                            maxWidth: '250px',
                        }}
                    ></WordHighLight>
                    <Row data-align-items-center data-margin-top-4>
                        <div data-color-999 data-font-size-12>
                            {[
                                r.unit_ratio !== 1
                                    ? `1${r.sales_unit_name}=${r.unit_ratio}${r.goods.stock_unit.name}`
                                    : '',
                                r.price_annotation,
                            ]
                                .filter(Boolean)
                                .join(';')}
                        </div>
                    </Row>
                </Column>
            ),
        },
        {
            dataIndex: 'net_order_count',
            key: 'name_net_sales_count',
            title: '销售笔数',
            align: 'right',
            width: 140,
            sorter: true,
            render: (v, r) => `${v}单`,
        },
        {
            dataIndex: 'net_sales_count',
            key: 'name_net_sales_amount',
            title: '销售量',
            align: 'right',
            width: 140,
            sorter: true,
            render: (v, r) => `${v}${r.sales_unit_name}`,
        },
        {
            dataIndex: 'net_sales_income',
            key: 'name_net_sales_income',
            title: '销售额',
            align: 'right',
            width: 140,
            sorter: true,
            render: (v, r) => `${v}元`,
        },
        {
            title: '操作',
            width: 96,
            align: 'center',
            render: (val, record) => (
                <div
                    className="action"
                    onClick={() => {
                        showLayer(<GoodsDetail goodsId={record.goods.id} />)
                    }}
                >
                    详情
                </div>
            ),
        },
    ]

    const nameRequestHandle = useRequest<
        {
            list: GoodSaleByName.GoodsDataList[]
            pagination: IPagination
            sum_net_sales_income: number
            sum_net_order_count: number
        },
        GoodSaleByName.Data
    >(
        (val?) => {
            return $post({
                url: '/finance/getgoodssalesstatistics',
                params: {
                    page: val?.pagination?.page ? val.pagination.page + 1 : 1,
                    limit: 30,
                    from_date: props.date[0],
                    ordering_type: sortKey,
                    ordering_desc: des,
                    to_date: props.date[1],
                    keyword: key,
                },
            })
        },
        {
            loadMore: true,
            isNoMore: isNoMore,
            manual: true,
            formatResult: data => {
                return {
                    ...data,
                    list: data.goods_data_list,
                    pagination: data.pagination,
                }
            },
            onError: errorCallBack,
        },
    )

    useUpdateEffect(() => {
        // @ts-ignore
        key && nameRequestHandle.run()
    }, [key, des, sortKey])

    return (
        <BaseDialog isShow title="商品搜索" onClose={() => layerManage.pop()}>
            <Column data-padding-24 className={cls()}>
                <SearchInput
                    placeholder="请输入关键词"
                    onSearch={setKey}
                    onDelete={() => {
                        setKey('')
                    }}
                ></SearchInput>
                <div className={cls('table')}>
                    <WithScrollLoad data-expaned data-overflow-hidden scrollloadhandle={nameRequestHandle}>
                        <Table
                            rowKey={record => record.pricing_method_id + record.sale_scene}
                            loading={nameRequestHandle.loading || nameRequestHandle.loadingMore || void 0}
                            bordered
                            defaultExpandAllRows
                            expandRowByClick
                            pagination={false}
                            onChange={(page, filter, sorter) => {
                                setSortParams(sorter)
                            }}
                            columns={goodNameColumns}
                            dataSource={nameRequestHandle.data?.list}
                            scroll={{ x: 'max-content', y: 330 }}
                        />
                    </WithScrollLoad>
                </div>
            </Column>
        </BaseDialog>
    )
}

export default GoodSaleSearch
